import React from "react";
import "./Pannel.styles.scss";

const Pannel = ({
  pannelSearchValue,
  showSearchField,
  autoCompleteData,
  pannel_fund_name,
  pannel_asset_class,
  pannel_classification,
  pannel_symbol,
  pannel_style,
  displayAutoCompleteOp,
  maxUpperBound,
  pannelAllocationValue,
  showPannelData,

  pannelSearchHandler,
  suggestionHandler,
  pannelAllocationHandler,
  addSecurity,
  cancelSecurity,
}) => {
  return showSearchField ? (
    <div className={`pannel`} id="table-pannel">
      {/* <td colSpan="3"> */}
      <div className="pannel-content1">
        <div>
          search and add a security to the list. Look up by either security name
          or symbol :{" "}
        </div>
        <div>
          <input
            type="text"
            value={pannelSearchValue}
            id="pannelSearchInput"
            onChange={(e) => pannelSearchHandler(e)}
          />
          {displayAutoCompleteOp && autoCompleteData.length > 0 ? (
            <ul className="add_suggestion">
              {autoCompleteData.map((data, i) => (
                <li
                  key={i}
                  index={i}
                  onClick={(e) => suggestionHandler(e)}
                >{`${data["symbol"]} : ${data["fund_name"]}`}</li>
              ))}
            </ul>
          ) : null}
        </div>
      </div>
      <div className="pannel-content2">
        <table className="pannel-content2-table">
          <thead>
            <tr>
              <th>Selected security</th>
              <th>Asset class</th>
              <th>classification</th>
              <th>style</th>
              <th>allocation(%)</th>
            </tr>
          </thead>
          <tbody>
            {(showPannelData && pannel_fund_name) || pannel_asset_class ? (
              <tr>
                <td>
                  {pannel_fund_name
                    ? `${pannel_fund_name}(${pannel_symbol})`
                    : ""}
                </td>
                <td>{pannel_asset_class}</td>
                <td>{pannel_classification}</td>
                <td>{pannel_style}</td>
                {maxUpperBound ? (
                  <td>
                    {pannel_fund_name || pannel_asset_class ? (
                      <input
                        type="number"
                        min="0"
                        max={maxUpperBound}
                        value={pannelAllocationValue}
                        style={{ width: "120px", textAlign: "center" }}
                        onChange={(e) => pannelAllocationHandler(e)}
                      />
                    ) : null}
                  </td>
                ) : (
                  <td>
                    {pannel_fund_name || pannel_asset_class ? (
                      <input
                        type="number"
                        min="0"
                        value={pannelAllocationValue}
                        style={{ width: "120px", textAlign: "center" }}
                        onChange={(e) => pannelAllocationHandler(e)}
                      />
                    ) : null}
                  </td>
                )}
              </tr>
            ) : null}
          </tbody>
        </table>

        {pannelAllocationValue > maxUpperBound && showPannelData ? (
          <div style={{ textAlign: "right" }}>
            <span
              className="dataWarning"
              style={{ fontSize: "12px" }}
            >{`Input value should be lesser than max-limit(${maxUpperBound})`}</span>
          </div>
        ) : (
          <div></div>
        )}
        <div className="pannel-btn-holder">
          {showPannelData ? (
            <button
              className="pannel-btn btn"
              onClick={() => addSecurity()}
              disabled={
                pannelAllocationValue > maxUpperBound || pannel_fund_name == ""
                  ? true
                  : false
              }
              id="add_security"
            >
              Add
            </button>
          ) : null}
          <button className="pannel-btn btn" onClick={() => cancelSecurity()}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

export default Pannel;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe/customTreeTable/pannel/Pannel.jsx